import { render, staticRenderFns } from "./AvisosCarousel.vue?vue&type=template&id=6b6f9f28&"
import script from "./AvisosCarousel.vue?vue&type=script&lang=js&"
export * from "./AvisosCarousel.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/avisosCarousel.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports